import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import {getColorFillTypeFromFillType, getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {ColorFillPropertyType} from '@Components/color-fill';

interface BaseFillColorPanelProps {
  colorObject: FillObject;
  onChangeColor(updatedColor: ColorStorage[]): void;
  onChangeColorEnded(updatedColor: ColorStorage[]): void;
  onChangeType(newType: ColorFillPropertyType): void;
}

export function BaseFillColorPanel({...props}: BaseFillColorPanelProps): ReactElement | null {
  const onChangeColorFillColor = (updatedColor: ColorStorage[]): void => {
    props.onChangeColor(updatedColor);
  };
  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    props.onChangeColorEnded(updatedColor);
  };
  const onChangeType = (newType: ColorFillPropertyType): void => {
    props.onChangeType(newType);
  };

  if (props.colorObject.fillType === FillTypes.NONE) {
    return null;
  }

  return (
    <PosterEditingBaseColorPanel
      id="vector-fill-color-panel"
      type={getColorFillTypeFromFillType(props.colorObject.fillType)}
      color={getColorObjectArrayFromFillColor(props.colorObject.fillColor)}
      onChangeColor={onChangeColorFillColor}
      onChangeEnded={onChangeColorEnded}
      onChangeType={onChangeType}
    />
  );
}
